/*
 * The texts of the mcp extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	sidebar: {
		mcp: 'MCP-Server',
	},
	pages: {
		mcp_info: {
			title: 'MCP-Server',
			connection: 'Verbindung',
			url: 'Adresse des Servers',
			copy_url: 'Adresse kopieren',
			url_copied: 'Adresse kopiert',
			connect:
				'Ein Assistent verbindet sich mit dieser Adresse und einem MCP-Token, den jede Person auf ihrer {link} anlegt; der Assistent sieht dann genau, was diese Person sehen darf.',
			security_page: 'Sicherheitsseite',
			limits: 'Höchstens {requests} Aufrufe und {writes} Änderungen pro Minute und Person. Protokoll {protocol}.',
			tools: 'Werkzeuge ({count})',
			read_only: 'liest nur',
			writes: 'ändert Daten',
			parameter: 'Parameter',
			type: 'Typ',
			description: 'Beschreibung',
			required: 'Pflicht',
			no_parameters: 'Keine Parameter.',
			output_schema: 'Ausgabe-Schema',
			no_tools: 'Der Server bietet noch keine Werkzeuge an.',
			instructions: 'Anweisungen an den Assistenten',
			instructions_hint: 'Bekommt jeder Assistent beim Verbinden, vor dem ersten Werkzeug.',
			load_failed: 'Die Angaben zum MCP-Server konnten nicht geladen werden.',
			try_again: 'Erneut versuchen',
		},
	},
};
